import React from "react";
import { Button, ButtonGroup, ToggleButton } from "react-bootstrap";

export const DASH_BTN_SIZE = "sm";

export const dashBtnClass = (className = "") =>
  ["dash-btn", className].filter(Boolean).join(" ");

const DashMedidasButton = React.forwardRef(
  ({ className, size = DASH_BTN_SIZE, ...props }, ref) => (
    <Button ref={ref} size={size} className={dashBtnClass(className)} {...props} />
  )
);

DashMedidasButton.displayName = "DashMedidasButton";

export const DashMedidasButtonGroup = ({
  className,
  size = DASH_BTN_SIZE,
  children,
  ...props
}) => (
  <ButtonGroup
    size={size}
    className={["dash-btn-group", className].filter(Boolean).join(" ")}
    {...props}
  >
    {children}
  </ButtonGroup>
);

export const DashMedidasToggleButton = ({
  className,
  size = DASH_BTN_SIZE,
  ...props
}) => (
  <ToggleButton size={size} className={dashBtnClass(className)} {...props} />
);

export default DashMedidasButton;
